import { FieldArrayItemType } from '@lib/components/ReactHookForm/types';

export default function getVisibleOptionsIds(
  fields: FieldArrayItemType[],
  searchValue: string,
): string[] {
  if (!searchValue.length) {
    return fields.map(({ id }) => id);
  }
  return fields
    .filter(({ values: optionValues, value: optionValue }) => {
      if (
        Array.isArray(optionValues) &&
        typeof optionValues?.[0] === 'string'
      ) {
        return (
          optionValues[0].toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        );
      }
      if (typeof optionValue === 'string') {
        return (
          optionValue.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        );
      }
      return false;
    })
    .map(({ id }) => id);
}
